<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4 mb-5">
    <div style="max-width:760px">
      <h3 class="mb-1">S3 Config</h3>
      <div style="font-style: italic; color:var(--bo-muted)">
        AWS S3-tilkobling (bilder + self-hosted APK-er). Lagres i Couchbase (ikke i kildekode/git);
        secret-nøkkelen lagres <strong>kryptert</strong>.
      </div>

      <div class="alert alert-info mt-3 py-2" style="font-size:0.88rem">
        <font-awesome-icon :icon="['fas', 'lock']" />
        Secret-nøkkelen vises aldri her igjen etter lagring. La feltet stå <strong>tomt</strong> for å
        beholde eksisterende — fyll det kun ut for å erstatte (f.eks. ved nøkkelrotasjon; ny nøkkel tas i
        bruk uten restart).
      </div>

      <config-lock ref="lock" :configured="isConfigured">
      <div class="row g-3 mt-1">
        <div class="col-md-6">
          <label class="form-label mb-1 s3-label">Bucket-navn (media)</label>
          <input class="form-control" type="text" v-model="form.bucketName" placeholder="cagista-s3-test" />
        </div>
        <div class="col-md-6">
          <label class="form-label mb-1 s3-label">Endpoint (offentlig URL-base for bilder)</label>
          <input class="form-control" type="text" v-model="form.endpoint"
                 placeholder="https://cagista-s3-test.s3.eu-north-1.amazonaws.com/" />
        </div>
        <div class="col-md-6">
          <label class="form-label mb-1 s3-label">Access key</label>
          <input class="form-control" type="text" v-model="form.accessKey" placeholder="AKIA…" autocomplete="off" />
        </div>
        <div class="col-md-6">
          <label class="form-label mb-1 s3-label">Secret key</label>
          <div class="mb-1">
            <span class="badge" :class="config.secretKeySet ? 'bg-success' : 'bg-secondary'">
              {{ config.secretKeySet ? 'Konfigurert ✓' : 'Ikke satt' }}
            </span>
            <span class="ms-2" style="color:var(--bo-muted); font-size:0.82rem">kilde: {{ sourceLabel(config.source) }}</span>
          </div>
          <div style="position:relative">
            <input :type="showSecret ? 'text' : 'password'" class="form-control" style="padding-right:38px"
                   v-model="form.secretKey" autocomplete="new-password"
                   :placeholder="config.secretKeySet ? '•••• (lagret — la stå tomt)' : 'Lim inn secret key'" />
            <button type="button" @click="showSecret = !showSecret"
                    :title="showSecret ? 'Skjul' : 'Vis'"
                    style="position:absolute; right:10px; top:50%; transform:translateY(-50%); border:none; background:none; color:var(--bo-muted); cursor:pointer; padding:0; line-height:1;">
              <font-awesome-icon :icon="['fas', showSecret ? 'eye-slash' : 'eye']" />
            </button>
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex align-items-center gap-3">
        <button class="bo_btn" @click="save" :disabled="saving">{{ saving ? 'Lagrer…' : 'Lagre' }}</button>
        <span v-if="message" :class="error ? 'text-danger' : 'text-success'">{{ message }}</span>
      </div>
      </config-lock>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ConfigLock from "@/components/other/ConfigLock";
import SettingsService from "@/services/settings/SettingsService";

export default {
  name: "S3Config",
  components: { LoadingSpinner, ConfigLock },
  computed: {
    // Already configured (→ starts locked): the S3 secret key is already stored server-side.
    isConfigured() { return !!this.config.secretKeySet; }
  },
  data() {
    return {
      loading: true,
      config: {},
      form: { bucketName: "", endpoint: "", accessKey: "", secretKey: "" },
      showSecret: false,
      saving: false,
      message: "",
      error: false
    };
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    sourceLabel(source) {
      if (source === "couchbase") return "Couchbase";
      if (source === "properties") return "properties (migrer: lagre her)";
      return "—";
    },
    loadConfig() {
      SettingsService.getS3Config().then(
        (response) => {
          this.config = response.data || {};
          this.form.bucketName = this.config.bucketName || "";
          this.form.endpoint = this.config.endpoint || "";
          this.form.accessKey = this.config.accessKey || "";
          this.loading = false;
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke hente konfigurasjon.");
        }
      );
    },
    save() {
      this.saving = true;
      this.message = "";
      this.error = false;
      SettingsService.saveS3Config({
        bucketName: this.form.bucketName,
        endpoint: this.form.endpoint,
        accessKey: this.form.accessKey,
        secretKey: this.form.secretKey
      }).then(
        (response) => {
          this.saving = false;
          this.config = response.data || {};
          this.form.secretKey = "";   // don't keep the secret in the DOM
          this.showSecret = false;
          this.error = false;
          this.message = "Lagret ✓ — tas i bruk umiddelbart (ingen restart).";
          this.$refs.lock.relock();   // re-lock after a successful save
        },
        (error) => {
          this.saving = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke lagre konfigurasjon.");
        }
      );
    },
    errMsg(error, fallback) {
      const data = error && error.response ? error.response.data : null;
      return (data && data.error) || fallback;
    }
  }
};
</script>

<style scoped>
.s3-label {
  font-size: 0.85rem;
  color: var(--bo-muted);
}
</style>
